import { cn } from "@/lib/utils";

/**
 * Animált bowling bábuk az Arizona Bowling márka színeiben (SMIL SVG animáció).
 * A háttérben álló bal és jobb bábuk enyhe áttetszőséggel adnak mélységet, míg a középső
 * fő bábu teljes kiemelést kap. A színek automatikusan alkalmazkodnak a témához (`--primary`, `--primary-foreground`).
 */
export function BowlingAnimation({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      fill="none"
      viewBox="0 0 512 512"
      aria-hidden="true"
      role="presentation"
      className={cn("size-16 shrink-0", className)}
      {...props}
    >
      {/* Jobb oldali bábu (háttér) */}
      <g>
        <g transform="translate(346.1,350.779)">
          <g transform="rotate(0)">
            <animateTransform
              repeatCount="indefinite"
              type="rotate"
              attributeName="transform"
              dur="3.003s"
              begin="0s"
              calcMode="spline"
              values="0; 0; 7; -7; 4; -4; 0; 0"
              keyTimes="0; 0.166666; 0.255555; 0.344444; 0.433333; 0.522222; 0.611111; 1"
              keySplines="0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1"
              fill="freeze"
            />
            <g transform="scale(0,0)">
              <animateTransform
                repeatCount="indefinite"
                type="scale"
                attributeName="transform"
                dur="3.003s"
                begin="0s"
                calcMode="spline"
                values="0 0; 0 0; 1 1; 1 1"
                keyTimes="0; 0.055555; 0.166666; 1"
                keySplines="0 0 1 1; 0 0 1 1; 0 0 1 1"
                fill="freeze"
              />
              <g transform="translate(-52.756,-245.334)">
                {/* Bábu test */}
                <g transform="matrix(1,0,0,1,52.756,122.792)">
                  <path
                    fill="var(--primary)"
                    opacity="0.65"
                    d="M10.795,-50.982C10.795,-50.982,10.729,-50.093,10.729,-50.093C10.583,-69.012,13.686,-83.768,19.901,-101.637C19.836,-112.178,11.843,-120.752,2.29,-121.596C-8.426,-122.542,-18.669,-113.548,-18.842,-101.637C-13.393,-83.734,-10.624,-69.17,-10.624,-50.456C-10.624,-50.456,-10.624,-51.052,-10.624,-51.052C-22.951,-27.734,-52.507,-4.682,-52.507,40.42C-52.507,75.884,-41.392,106.731,-25.02,122.542C-25.02,122.542,25.02,122.542,25.02,122.542C41.392,106.731,52.507,75.884,52.507,40.42C52.507,-4.574,24.01,-27.734,10.795,-50.982Z"
                  />
                </g>
                {/* Gallér csíkok */}
                <g transform="matrix(1,0,0,1,52.845,55.771)">
                  <path
                    fill="var(--primary-foreground)"
                    d="M11.907,-3.373C11.907,-3.373,-11.907,-3.373,-11.907,-3.373C-11.907,-3.373,-11.879,-3.13,-11.879,-3.13C-11.879,-3.13,-11.232,3.184,-11.232,3.184C-11.232,3.184,-11.218,3.373,-11.218,3.373C-11.218,3.373,11.151,3.373,11.151,3.373C11.151,3.373,11.907,-3.373,11.907,-3.373Z"
                  />
                </g>
                <g transform="matrix(1,0,0,1,52.798,66.565)">
                  <path
                    fill="var(--primary-foreground)"
                    d="M10.915,-3.373C10.915,-3.373,-10.915,-3.373,-10.915,-3.373C-10.915,-3.373,-10.902,-3.036,-10.902,-3.036C-10.902,-3.036,-10.686,3.171,-10.686,3.171C-10.686,3.171,-10.686,3.373,-10.686,3.373C-10.686,3.373,10.699,3.373,10.699,3.373C10.699,3.373,10.915,-3.373,10.915,-3.373Z"
                  />
                </g>
                <g transform="matrix(1,0,0,1,52.932,44.977)">
                  <path
                    fill="var(--primary-foreground)"
                    d="M13.776,-3.373C13.776,-3.373,-13.776,-3.373,-13.776,-3.373C-13.776,-3.373,-12.574,3.373,-12.574,3.373C-12.574,3.373,12.439,3.373,12.439,3.373C12.439,3.373,13.776,-3.373,13.776,-3.373Z"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>

      {/* Bal oldali bábu (háttér) */}
      <g>
        <g transform="translate(165.9,350.779)">
          <g transform="rotate(0)">
            <animateTransform
              repeatCount="indefinite"
              type="rotate"
              attributeName="transform"
              dur="3.003s"
              begin="0s"
              calcMode="spline"
              values="0; 0; 7; -7; 4; -4; 0; 0"
              keyTimes="0; 0.222222; 0.311111; 0.4; 0.488889; 0.577778; 0.666667; 1"
              keySplines="0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1"
              fill="freeze"
            />
            <g transform="scale(0,0)">
              <animateTransform
                repeatCount="indefinite"
                type="scale"
                attributeName="transform"
                dur="3.003s"
                begin="0s"
                calcMode="spline"
                values="0 0; 0 0; 1 1; 1 1"
                keyTimes="0; 0.111111; 0.222222; 1"
                keySplines="0 0 1 1; 0 0 1 1; 0 0 1 1"
                fill="freeze"
              />
              <g transform="translate(-52.756,-245.334)">
                {/* Bábu test */}
                <g transform="matrix(1,0,0,1,52.756,122.792)">
                  <path
                    fill="var(--primary)"
                    opacity="0.65"
                    d="M10.795,-50.982C10.795,-50.982,10.729,-50.093,10.729,-50.093C10.583,-69.012,13.685,-83.768,19.9,-101.637C19.835,-112.178,11.843,-120.752,2.29,-121.596C-8.426,-122.542,-18.669,-113.548,-18.842,-101.637C-13.393,-83.734,-10.624,-69.17,-10.624,-50.456C-10.624,-50.456,-10.624,-51.052,-10.624,-51.052C-22.951,-27.734,-52.507,-4.682,-52.507,40.42C-52.507,75.884,-41.392,106.731,-25.02,122.542C-25.02,122.542,25.02,122.542,25.02,122.542C41.392,106.731,52.507,75.884,52.507,40.42C52.507,-4.574,24.01,-27.734,10.795,-50.982Z"
                  />
                </g>
                {/* Gallér csíkok */}
                <g transform="matrix(1,0,0,1,52.845,55.771)">
                  <path
                    fill="var(--primary-foreground)"
                    d="M11.907,-3.373C11.907,-3.373,-11.907,-3.373,-11.907,-3.373C-11.907,-3.373,-11.88,-3.13,-11.88,-3.13C-11.88,-3.13,-11.233,3.184,-11.233,3.184C-11.233,3.184,-11.219,3.373,-11.219,3.373C-11.219,3.373,11.15,3.373,11.15,3.373C11.15,3.373,11.907,-3.373,11.907,-3.373Z"
                  />
                </g>
                <g transform="matrix(1,0,0,1,52.798,66.565)">
                  <path
                    fill="var(--primary-foreground)"
                    d="M10.915,-3.373C10.915,-3.373,-10.915,-3.373,-10.915,-3.373C-10.915,-3.373,-10.902,-3.036,-10.902,-3.036C-10.902,-3.036,-10.686,3.171,-10.686,3.171C-10.686,3.171,-10.686,3.373,-10.686,3.373C-10.686,3.373,10.699,3.373,10.699,3.373C10.699,3.373,10.915,-3.373,10.915,-3.373Z"
                  />
                </g>
                <g transform="matrix(1,0,0,1,52.933,44.977)">
                  <path
                    fill="var(--primary-foreground)"
                    d="M13.776,-3.373C13.776,-3.373,-13.776,-3.373,-13.776,-3.373C-13.776,-3.373,-12.575,3.373,-12.575,3.373C-12.575,3.373,12.439,3.373,12.439,3.373C12.439,3.373,13.776,-3.373,13.776,-3.373Z"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>

      {/* Középső bábu (előtér, fő fókusz) */}
      <g>
        <g transform="translate(253.438,410.55)">
          <g transform="rotate(0)">
            <animateTransform
              repeatCount="indefinite"
              type="rotate"
              attributeName="transform"
              dur="3.003s"
              begin="0s"
              calcMode="spline"
              values="0; 0; 7; -7; 4; -4; 0; 0"
              keyTimes="0; 0.111111; 0.2; 0.288889; 0.377778; 0.466667; 0.555556; 1"
              keySplines="0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1"
              fill="freeze"
            />
            <g transform="scale(0,0)">
              <animateTransform
                repeatCount="indefinite"
                type="scale"
                attributeName="transform"
                dur="3.003s"
                begin="0s"
                calcMode="spline"
                values="0 0; 1 1; 1 1"
                keyTimes="0; 0.111111; 1"
                keySplines="0 0 1 1; 0 0 1 1"
                fill="freeze"
              />
              <g transform="translate(-66.709,-310.462)">
                {/* Bábu test */}
                <g transform="matrix(1,0,0,1,66.709,155.356)">
                  <path
                    fill="var(--primary)"
                    d="M13.663,-64.53C13.663,-64.53,13.58,-63.405,13.58,-63.405C13.395,-87.351,17.322,-106.028,25.189,-128.646C25.107,-141.988,14.991,-152.84,2.899,-153.908C-10.664,-155.106,-23.631,-143.721,-23.85,-128.646C-16.953,-105.985,-13.448,-87.551,-13.448,-63.864C-13.448,-63.864,-13.448,-64.618,-13.448,-64.618C-29.051,-35.105,-66.459,-5.927,-66.459,51.16C-66.459,96.049,-52.39,135.092,-31.668,155.106C-31.668,155.106,31.668,155.106,31.668,155.106C52.39,135.092,66.459,96.049,66.459,51.16C66.459,-5.79,30.39,-35.105,13.663,-64.53Z"
                  />
                </g>
                {/* Gallér csíkok */}
                <g transform="matrix(1,0,0,1,66.821,70.525)">
                  <path
                    fill="var(--primary-foreground)"
                    d="M15.071,-4.27C15.071,-4.27,-15.071,-4.27,-15.071,-4.27C-15.071,-4.27,-15.036,-3.962,-15.036,-3.962C-15.036,-3.962,-14.217,4.031,-14.217,4.031C-14.217,4.031,-14.2,4.27,-14.2,4.27C-14.2,4.27,14.115,4.27,14.115,4.27C14.115,4.27,15.071,-4.27,15.071,-4.27Z"
                  />
                </g>
                <g transform="matrix(1,0,0,1,66.761,84.187)">
                  <path
                    fill="var(--primary-foreground)"
                    d="M13.816,-4.27C13.816,-4.27,-13.816,-4.27,-13.816,-4.27C-13.816,-4.27,-13.799,-3.842,-13.799,-3.842C-13.799,-3.842,-13.525,4.014,-13.525,4.014C-13.525,4.014,-13.525,4.27,-13.525,4.27C-13.525,4.27,13.542,4.27,13.542,4.27C13.542,4.27,13.816,-4.27,13.816,-4.27Z"
                  />
                </g>
                <g transform="matrix(1,0,0,1,66.932,56.863)">
                  <path
                    fill="var(--primary-foreground)"
                    d="M17.436,-4.27C17.436,-4.27,-17.436,-4.27,-17.436,-4.27C-17.436,-4.27,-15.916,4.27,-15.916,4.27C-15.916,4.27,15.745,4.27,15.745,4.27C15.745,4.27,17.436,-4.27,17.436,-4.27Z"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
